<div class="pdf-viewer">
  <button class="pdf-close" type="button" (click)="closeDialog()" aria-label="Chiudi visualizzatore PDF">
    <i class="bi bi-x-lg" aria-hidden="true"></i>
  </button>
  <embed [src]="currentSrc" type="application/pdf" class="pdf-embed">
</div>
